<template>
  <div>
    <group label-width="4.5em" label-margin-right="2em" label-align="left">
      <cell :title="$t('cart.order.couponCode')" :value="$t('cart.order.useCoupon')" is-link @click.native="showCouponPopup = true"></cell>

      <popup-picker :cancel-text="$t('kol.header.cancel')" :confirm-text="$t('kol.header.confirm')" :title="$t('cart.order.shippingMethod')" @on-change="onShippingMethodChanged" :data="deliveryOptions" v-model="shippingMethod" value-text-align="right" show-name></popup-picker>
      <!--         <img slot="restricted-label" style="display:inline-block;vertical-align:middle;" src="http://dn-placeholder.qbox.me/110x110/FF2D55/000" width="24" height="24"> -->
      <x-switch title="使用積分優惠" :inline-desc="userCredit" v-model="useCredit"></x-switch>
    </group>

    <group title="帳單詳情">
      <AddressEntry :address="currentAddress" @click.native="showAddressList"></AddressEntry>
      <x-textarea :title="$t('cart.order.remarks')" placeholder="" :show-counter="false" :rows="3" v-model="remarks"></x-textarea>
    </group>
    <p v-if="this.shippingMethod[0] == 'S'" class="notice">－ 如選擇自取只需提供電話號碼</p>

    <group>
      <!-- <cell :title="$t('cart.order.tariff')"><span>{{tariff}}</span></cell> -->
      <cell :title="$t('cart.order.shippingFee')"><span>{{shippingFee}}</span></cell>
      <cell :title="$t('cart.order.discount')"><span style="color: red;">-{{discount}}</span></cell>
      <cell v-if="actualAmount < 10" :title="$t('cart.totalPrice')"><span>10</span></cell>
      <cell v-else :title="$t('cart.totalPrice')"><span>{{actualAmount}}</span></cell>
    </group>
      <div class="agreement"><check-icon :value.sync="agree" type="plain" >本人已閱讀並明白及同意</check-icon><span style="text-decoration: underline;" @click="$router.push('/package/termsAndConditions')">用户網購條款</span></div>
      <p class="notice" >－ 客人如果對其準備下單的網購產品有任何疑問﹐請客人不應下單避免不必要的爭議。</p>
      <p style="display: block; color: red; padding: 10px 10px 10px 15px">－ 客人請確保已填寫<span class="highlight">地址(如適用)</span>﹐<span class="highlight">聯絡電話</span>及<span class="highlight">確認條款。</span></p>
      <p v-if="this.shippingMethod[0] == 'S'" class="notice" style="justify-content: start !important;">－ 客人請確保已<span class="highlight">確認條款。</span></p>
      <p v-if="this.shippingMethod[0] == 'S'" class="notice" style="justify-content:flex-start">－ 自取地址詳情請聯絡客戶服務主任。</p>
    <br>
    <div v-transfer-dom>
      <confirm v-model="showCouponPopup" show-input ref="couponPopup" :title="$t('cart.order.useCoupon')" @on-confirm="onComfirmCoupon" :confirm-text="$t('general.confirm')" :cancel-text="$t('general.cancel')">
      </confirm>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
import { GroupTitle, Group, Cell, XInput, Selector, PopupPicker, Datetime, XNumber, ChinaAddressData, XAddress, XTextarea, XSwitch, CellFormPreview, Actionsheet, Confirm, TransferDomDirective as TransferDom, CheckIcon } from 'vux'
import AddressEntry from '../components/AddressEntry'
import Cookies from 'js-cookie';

export default {
  name: 'CheckoutForm',
  directives: {
    TransferDom
  },
  components: {
    Group,
    GroupTitle,
    Cell,
    XInput,
    Selector,
    PopupPicker,
    XAddress,
    Datetime,
    XNumber,
    XTextarea,
    XSwitch,
    CellFormPreview,
    Actionsheet,
    Confirm,
    AddressEntry,
    CheckIcon
  },
  props: {},
  data() {
    return {
      deliveryOptions: [
        [
          {
            name: this.$t('cart.order.selfPickup'),
            value: 'S'
          },
          {
            name: this.$t('cart.order.mail'),
            value: 'M'
          },
        ]
      ],
      couponCode: '',
      showCouponPopup: false,
      shippingMethod: ['M'],
      remarks: '',
      agree: false,
      useCredit: false,
      currentUser: {},
    }
  },
  created() {
    if(Cookies.get('redirect') !== 'true'){
      this.getUserDetail();
    }
    // this.currentUser = JSON.parse(localStorage.currentUser);
    // this.shippingMethod = this.$store.state.shippingMethod;
  },
  mounted() {},
  watch: {
    agree: function(){
      if (this.agree == true && this.shippingMethod[0] == 'M' && this.$store.state.currentAddress.detail !== '' && this.$store.state.currentAddress.mobile !== ''){
        this.$emit('confirm', true)
      }else if(this.agree == true && this.shippingMethod[0] == 'S' && this.$store.state.currentAddress.mobile !== ''){
        this.$emit('confirm', true)
      }else{
        this.$emit('confirm', false)
      }
    },
    useCredit: function() {
      if (this.useCredit == true){
        this.$emit('useCredit', true)
      }else{
        this.$emit('useCredit', false)
      }
    },
  },
  computed: {
    ...mapGetters([
      'getExchangePrice',
      'getRoundPrice',
      'getHKPrice',
      'getPriceByCurrency',
      'convertToHKPriceByCurrency',
    ]),
    // tariff() {
    //   return (this.shippingMethod[0] == 'M') && (this.isEmptyObject(this.currentAddress) == false )&& (this.currentAddress.country == 'cn') ? this.getRoundPrice(this.$store.getters.tariff) : 0;
    // },
    shippingFee() {
      // return this.shippingMethod == 'M' ? this.getExchangePrice(this.$store.getters.shippingFee) : 0;

      // Shipping Fee all count in HK Price then convert to related currency

      // let shippingFee = {
      //   cn: this.convertToHKPriceByCurrency('CNY',28),
      //   hk:40,
      //   mo:40
      // }
      // let price = 0;
      // if((this.shippingMethod[0] == 'M')&& (this.isEmptyObject(this.currentAddress) ==false )&&(this.currentAddress.country)){
      //   price = shippingFee[`${this.currentAddress.country}`];
      // }
      // return this.getExchangePrice(price);
      // return this.$store.getters.shippingFee;
      if(this.shippingMethod == 'M'){
        if(this.totalPrice < 300){
          return 28
        }else{
          return 0
        }
      }else if(this.shippingMethod == 'S'){
        return 0
      }

    },
    discount() {
      let ratePart = this.getRoundPrice(this.$store.getters.discount);
      let fixPart = 20;
      let discount = 0;
      switch(this.couponCode){
        case '123123':
         discount = fixPart; 
        break;
        case '123168':
         discount = ratePart + fixPart; 
        break;
        case '168168':
         discount = ratePart; 
        break;
      }
      return discount;
    },
    totalPrice() {
      return this.$store.getters.totalPricePackages;
    },
    actualAmount() {
      if(this.useCredit == true){
        var actualAmount = this.totalPrice + this.shippingFee - this.discount - this.currentUser.credit;
        if(actualAmount < 10){
          var usedCredit = this.totalPrice + this.shippingFee - 10
          this.$emit('updateActualAmount', 10);
          this.emitOrderInfo(usedCredit);
          return actualAmount.toFixed(2);
        }
        this.$emit('updateActualAmount', actualAmount);
        this.emitOrderInfo(this.currentUser.credit);
        return actualAmount.toFixed(2);
      }
      var actualAmount = this.totalPrice + this.shippingFee - this.discount ;
      this.$emit('updateActualAmount', actualAmount);
      this.emitOrderInfo();
      return actualAmount.toFixed(2);
    },
    currentAddress() {
      // console.log(this.$store.state.currentAddress);
      return this.$store.state.currentAddress;
    },
    userCredit(){
      var price = this.totalPrice  + this.shippingFee - this.discount - 10
      if(this.currentUser.credit>this.actualAmount && this.currentUser.credit>price){
        return '你有'+this.currentUser.credit+'積分，可優惠'+price+'元'
      }else{
        return '你有'+this.currentUser.credit+'積分，可優惠'+this.currentUser.credit+'元'
      }
    },
    
  },
  methods: {
    onComfirmCoupon(couponCode) {
      this.couponCode = couponCode;
      this.showCouponPopup = false;
    },
    emitOrderInfo(usedCredit) {
      var order = {
        tariff: 0,
        shippingFee: this.shippingFee,
        discount: this.discount,
        totalAmount: this.totalPrice,
        remarks: this.remarks,
        shippingMethod: this.shippingMethod[0],
        addressID: this.isEmptyObject(this.currentAddress) == false ? this.currentAddress.ID : 0,
        credits: usedCredit
      };
      this.$emit('updateOrder', order);
    },
    showAddressList(){
      this.$router.push('/cart/address');
    },
    isEmptyObject(obj) {
      if (obj == null) {
        return true;
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    onShippingMethodChanged(val){
      // console.log(val);
      this.$store.commit('updateShippingMethod', val);
    },
    getUserDetail() {

      this.$store.dispatch('Account/getUserDetail', {}).then((json) => {

        if (json.status == 401) {
          Cookies.remove('token');
          this.$router.push('/login');
        } else {
          this.$store.commit("updateCurrentUser", json.data);
          this.currentUser = json.data
          // console.log(JSON.parse(localStorage.getItem('currentUser')));
          // console.log(json.data);
        }
      }).catch((err) => {
        console.error(err);
      });
    },
  },
}

</script>
<style type="text/css">
.notice{
  display: flex; 
  justify-content: start; 
  padding: 10px 10px 10px 15px; 
  color: red
}
.agreement{
  display: flex; 
  justify-content: center; 
  padding-top: 15px;
}
.weui-switch{
  min-width: 0px !important;
}
.highlight{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/Package/components/CheckoutForm.vue